<template>
  <div>
    <template v-if="newMode">
      <div class="row">
        <div class="col-sm-10 col-xs-8">
          <h1>Projects</h1>
        </div>
        <div class="col-sm-2 col-xs-4 text-right">
          <a href="/" class="btn btn-default btn-filter"><i class="fa fa-filter"></i> Filters</a>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-6 project-card" v-for="(project, idx) in items" :key="idx">
          <div class="project-thumb">
            <div class="project-image">
              <img @click.stop="goToProject(project.id)" v-if="project.logo" :src="project.logo.preview" style="cursor: pointer;" :alt="project.name">
              <img @click.stop="goToProject(project.id)" v-else :src="require('@/assets/images/cover.jpg')" style="cursor: pointer;" :alt="project.name">

              <div class="project-image-details">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-xs-8">
                      <p>Price from</p>
                      <strong v-if="project.totalApartments > 1">{{ $formatter.formatPrice(project.lowerPrice) }}-{{ $formatter.formatPrice(project.higherPrice) }} €</strong>
                      <strong v-else>{{ $formatter.formatPrice(project.lowerPrice) }} €</strong>
                    </div>
                    <div class="col-xs-4 text-right">
                      <span class="label label-success" v-if="project.totalApartments - project.soldApartments - project.reservedApartments > 0">Available</span>
                      <span class="label label-danger" v-else>SOLD</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="project-details">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-xs-8">
                    <h1 class="oneliner" @click.stop="goToProject(project.id)" style="cursor: pointer;">{{ project.name }}</h1>
                    <address class="twoliner">
                      {{ project.address + (project.city ? ', ' + project.city : '') }},
                      Deutschland
                    </address>
                  </div>
                  <div class="col-xs-4 text-center">
                    <i style="cursor: pointer;" @click.stop="goToProjectMap(project.id)" class="fa fa-map-marker-alt location-icon"></i>
                  </div>
                </div>
                <div class="row">
                  <hr>
                </div>

                <div class="row mgb-10">
                  <div class="col-xs-6"><span class="project-field">Available units</span></div>
                  <div class="col-xs-6 text-right" v-if="project.totalApartments > 1"><strong>{{ project.totalApartments - project.soldApartments - project.reservedApartments }} of {{ project.totalApartments }}</strong></div>
                  <div class="col-xs-6 text-right" v-else><strong>Building</strong></div>
                </div>

                <div class="row mgb-10">
                  <div class="col-xs-6"><span class="project-field">Rendite</span></div>
                  <div class="col-xs-6 text-right"><strong>{{ (project.totalRent / project.totalPrice * 100).toFixed(1) }}% p.a.</strong></div>
                </div>

                <div class="row mgb-10">
                  <div class="col-xs-6"><span class="project-field">rental income</span></div>
                  <div class="col-xs-6 text-right" v-if="project.totalApartments > 1"><strong>{{ $formatter.formatPrice(project.lowerRent) }} - {{ $formatter.formatPrice(project.higherRent) }}€</strong></div>
                  <div class="col-xs-6 text-right" v-else><strong>{{ $formatter.formatPrice(project.lowerRent) }}€</strong></div>
                </div>

                <div class="row mgb-10">
                  <div class="col-xs-6"><span class="project-field">size</span></div>
                  <div class="col-xs-6 text-right" v-if="project.totalApartments > 1"><strong>{{ project.lowerArea }} m<sup>2</sup> - {{ project.higherArea }} m<sup>2</sup></strong></div>
                  <div class="col-xs-6 text-right" v-else><strong>{{ project.lowerArea }} m<sup>2</sup></strong></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="!_is('prospect')">
        <div class="row">
          <div class="col-lg-12">
            <panel>
              <apexcharts height="350px" type="line" id="a0" :options="data.main.chartOptions" :series="data.main.series"></apexcharts>
            </panel>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-6">
                <panel title="Agencies">
                  <apexcharts height="100px" type="bar" id="a1" :options="data.bars.agencies.chartOptions" :series="data.bars.agencies.series"></apexcharts>
                </panel>
              </div>
              <div class="col-sm-6">
                <panel title="Agents">
                  <apexcharts height="100px" type="bar" id="a2" :options="data.bars.agents.chartOptions" :series="data.bars.agents.series"></apexcharts>
                </panel>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <panel title="Projects">
                  <apexcharts height="100px" type="bar" id="a3" :options="data.bars.projects.chartOptions" :series="data.bars.projects.series"></apexcharts>
                </panel>
              </div>
              <div class="col-sm-6">
                <panel title="Apartments">
                  <apexcharts height="100px" type="bar" id="a4" :options="data.bars.apartments.chartOptions" :series="data.bars.apartments.series"></apexcharts>
                </panel>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <project-index :table-only="true" :title="'Latest projects'" :layout="'dashboard'"></project-index>
          </div>
        </div>
        <div class="row" v-if="_can('readSales')">
          <div class="col-sm-12">
            <sale-index :table-only="true" :title="'Latest offers'" :layout="'dashboard'"></sale-index>
          </div>
        </div>
      </template>
      <template v-else>
        <project-index :table-only="true" :collapse-apartments="true" :title="'Projects'" :layout="'prospect'"></project-index>
      </template>
    </template>
  </div>
</template>

<script>
import Panel from '@/components/_partial/_atomic/panel'
import ProjectIndex from '../project/Index'
import SaleIndex from '../sale/Index'

import ProjectService from '@/services/project.service'

export default {
  name: 'Index',
  components: { SaleIndex, ProjectIndex, Panel },

  data: function () {
    return {
      newMode: true,
      items: [],
      services: {
        project: ProjectService
      },
      defaultOptions: {
        chart: {
          sparkline: {
            enabled: true
          }
        },
        dataLabels: {
          enabled: false
        },
        grid: {
          show: false
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        xaxis: {
          labels: {
            show: false
          },
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        }
      },
      data: {
        main: {
          chartOptions: {
            chart: {
              id: 'main',
              sparkline: {
                enabled: false
              }
            },
            colors: ['#ff7043', '#66bb6a'],
            fill: { colors: ['#ff7043', '#66bb6a'] },
            stroke: {
              width: 2,
              lineCap: 'round'
            },
            xaxis: {
              labels: {
                show: true
              },
              categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            }
          },
          series: [{
            name: 'Offers',
            data: [25, 40, 30, 35, 8, 52, 17, 0, 10, 42, 1, 9]
          }, {
            name: 'Sales',
            data: [25, 50, 0, 15, 18, 32, 27, 14, 10, 8, 1, 13]
          }]
        },
        bars: {
          agencies: {
            chartOptions: {
              chart: {
                id: 'agencies'
              },
              colors: ['#4CAF50'],
              fill: { colors: ['#4CAF50'] }
            },
            colors: ['#4CAF50'],
            series: [{
              name: 'Agencies',
              data: [25, 40, 30, 35, 8, 52, 17, 0, 10, 42, 1, 9]
            }]
          },
          agents: {
            chartOptions: {
              chart: {
                id: 'agents'
              },
              colors: ['#EA3546'],
              fill: { colors: ['#EA3546'] }
            },
            series: [{
              name: 'Agents',
              data: [25, 40, 30, 35, 8, 52, 17, 0, 10, 42, 1, 9]
            }]
          },
          projects: {
            chartOptions: {
              chart: {
                id: 'projects'
              },
              colors: ['#03A9F4'],
              fill: { colors: ['#03A9F4'] }
            },
            colors: ['#03A9F4'],
            series: [{
              name: 'Projects',
              data: [25, 40, 30, 35, 8, 52, 17, 0, 10, 42, 1, 9]
            }]
          },
          apartments: {
            chartOptions: {
              chart: {
                id: 'apartments'
              },
              colors: ['#775DD0'],
              fill: { colors: ['#775DD0'] }
            },
            colors: ['#775DD0'],
            series: [{
              name: 'Apartments',
              data: [25, 40, 30, 35, 8, 52, 17, 0, 10, 42, 1, 9]
            }]
          }
        }
      }
    }
  },

  methods: {
    goToProject (projectId) {
      this.$router.push('/project/details/' + projectId + '#top-tab1')
    },
    goToProjectMap (projectId) {
      this.$router.push('/project/details/' + projectId + '#top-tab4')
    }
  },

  beforeMount () {
    this.services['project'].getList({
      'expand': 'apartments,apartments.data,creator,accessItems,modelFiles,files,images,fileSlots',
      'filter': {
        'on_dashboard': 1
      }
    }, (data) => {
      this.items = data
    })
    for (let i in this.data.bars) {
      this.data.bars[i].chartOptions = Object.assign(this.data.bars[i].chartOptions, this.defaultOptions)
    }
    this.data.main.chartOptions = Object.assign(this.defaultOptions, this.data.main.chartOptions)
  },

  mounted () {

  }
}
</script>

<style scoped>
  .oneliner {
    flex-grow: 1;
    max-height: 38px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .twoliner {
    flex-grow: 1;
    max-height: 38px;
    min-height: 38px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .project-card {
    max-height: 549px;
  }

  .location-icon:hover {
    color: #61b06c;
  }
</style>
